import { jsx } from "../../../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.es.js";
import { Alignment } from "../../../foundations/alignment.es.js";
import { Spacing } from "../../../foundations/spacing.es.js";
import { styled } from "@mui/material";
import { Displaying } from "../../../foundations/displaying.es.js";
import { Button } from "../../button/button.es.js";
const CustomDropzoneActionButtonContainer = styled("div")({
  marginTop: Spacing["750"],
  display: Displaying.flex,
  justifyContent: Alignment.center
});
function DropzoneActionButton({
  onClick,
  text,
  icon
}) {
  return /* @__PURE__ */ jsx(CustomDropzoneActionButtonContainer, { onClick, children: /* @__PURE__ */ jsx(Button, { color: "primary", variant: "contained", size: "medium", endIcon: icon, children: text }) });
}
export {
  DropzoneActionButton
};
//# sourceMappingURL=action-button.es.js.map
